"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var RadioButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RadioButtonGroup, _React$Component);

  function RadioButtonGroup() {
    (0, _classCallCheck2.default)(this, RadioButtonGroup);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RadioButtonGroup).apply(this, arguments));
  }

  (0, _createClass2.default)(RadioButtonGroup, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this$props = this.props,
          cards = _this$props.cards,
          name = _this$props.name,
          onChange = _this$props.onChange,
          selectedValue = _this$props.selectedValue;
      return {
        radioButtonGroup: {
          cards: cards,
          name: name,
          onChange: onChange,
          selectedValue: selectedValue
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          cards = _this$props2.cards,
          children = _this$props2.children,
          className = _this$props2.className,
          style = _this$props2.style;

      if (children.length === 0) {
        return null;
      } // Remove null children, which could be passed by way of a conditional
      // e.g. {hasData && <RadioButton ... />}


      var realChildren = children.filter(function (child) {
        return child !== null;
      });
      return _react.default.createElement("div", {
        className: (0, _classnames.default)((0, _defineProperty2.default)({
          'radio-button-group': true,
          'flex-row': cards
        }, className, className)),
        style: style
      }, realChildren);
    }
  }]);
  return RadioButtonGroup;
}(_react.default.Component);

;
RadioButtonGroup.childContextTypes = {
  radioButtonGroup: _propTypes.default.object
};
RadioButtonGroup.defaultProps = {
  selectedValue: null
};
var _default = RadioButtonGroup;
exports.default = _default;